import { withEffect } from './withEffect';
export function withSubscription(callback, subscribable) {
    return withEffect(function () {
        setImmediate(callback);
        return subscribable.subscribe(callback);
    });
}
//# sourceMappingURL=withSubscription.js.map